// src/components/common/ServiceAreaNotice.js
import React from "react";
import { MapPin, Info } from "lucide-react";
import "./ServiceAreaNotice.css";

const ServiceAreaNotice = ({ variant = "info" }) => {
  return (
    <div className={`service-area-notice ${variant}`}>
      <div className="notice-icon">
        <MapPin size={20} />
      </div>
      <div className="notice-content">
        <h4>Delivery Across India</h4>
        <p>
          We deliver to all Indian states. Delivery is free within Kerala.
          Delivery charges apply for other states.
        </p>
      </div>
    </div>
  );
};

export default ServiceAreaNotice;
